<template>
<!--  contact details -->
  <div class="">
    <div class="outContact">
      <el-form ref="form" :model="form" :rules="contactRules" :status-icon="true" :show-message="false">
        <div class="left">
          <el-form-item>
            <el-select v-model="form.phone_code" popper-class="sb">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="middle">
          <el-form-item prop="phone">
            <el-input v-model="form.phone" placeholder="Phone Number"></el-input>
          </el-form-item>
        </div>
        <div class="rights">
          <el-form-item prop="recipient_name">
            <el-input v-model=" form.recipient_name" placeholder="Name"></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "contactInput",
  data(){
    return{
      options:[
        {label:"+1",value:1},
      ],
      form:{
        phone_code:1,
        phone: "",
        recipient_name: "",
      },
      contactRules:{
        phone: [
          { required: true, message: '',trigger: ['blur', 'change'] }
        ],
        recipient_name: [
          { required: true, message: '',trigger: ['blur', 'change'] }
        ],

      }
    }
  },
  methods:{
    validateForm() {
      let flag = false
      this.$refs['form'].validate((valid) => {
        flag = valid
      })
      return flag
    },
    validateClear(){
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
.outContact{
  display: flex;
  /deep/ .el-form{
    display: flex;
    width: 100%;
  }
  .left{
    flex: 1;
    /deep/ .el-input__inner{
      border-bottom-right-radius: 0;
      border-top-right-radius: 0;
      border-right: none;
    }
  }
  .middle{
    flex: 3;
    /deep/ .el-input__inner{
      border-radius: 0;
      //border-bottom-left-radius: 0;
      //border-top-left-radius: 0;
      border-right: none;
    }
  }
  .rights{
    flex: 3;
    /deep/ .el-input__inner{
      border-bottom-left-radius: 0;
      border-top-left-radius: 0;
    }
  }
}
</style>
